import httpClient from './_httpClient';

const END_POINT = '/sms-credentials';
function endpoint(scopeId) {
  return "/scopes/" + scopeId + END_POINT;
}

const getSmsCredentialsByScope = (scopeId) => httpClient.get(endpoint(scopeId));
const updateSmsCredentials = (scopeId, mailCredentials) => httpClient.put(endpoint(scopeId), mailCredentials);

export {
  getSmsCredentialsByScope,
  updateSmsCredentials,
}
